const autocompleteModalFilterUser = {
  site: 'Sites',
  role: 'Perfis'
};

export default autocompleteModalFilterUser;
